// Centralized constants for Agent Voice Settings
export const AGENT_TONE_VALUES = [
    'professional',
    'friendly',
    'direct',
    'polite',
    'personable',
    'casual',
    'enthusiastic',
    'formal',
];
export const VOICE_SETTINGS_DEFAULTS = {
    name: '',
    temperature: 0.75,
    tone: [],
    active: true,
    disallowedTopics: '',
    greeting: '',
    voice: '',
    voiceModelLLM: 'gpt-4o-mini',
    voiceModelSTT: 'whisper-1',
};
//# sourceMappingURL=agent-voice-settings-constants.js.map